export enum PageUrls {
	MAIN = '/',
	SERVICES = '/services/',
	CAREERS = '/careers/',
	CASE_STUDIES = '/case-studies/',
	CONTACT = '/contact/',
	FAQ = '/faq/',
	ABOUT_US = '/about-us/',
	ORIGINS = '/about-us/origins/',
	HOW_WE_WORK = '/about-us/how-we-work/',
	DESIGN = '/services/design/',
	DEVELOPMENT = '/services/development/',
	ASSETS_TRACKING = '/services/location-and-asset-tracking/',
	INTEGRATIONS = '/services/integrations/',
	DEVOPS = '/services/devops/',
	IOT = '/services/iot/',
	STAFF_AUGMENTATION = '/services/staff-augmentation/',
	DEDICATED_TEAM = '/services/dedicated-team/',
	TIME_AND_MATERIAL = '/services/time-and-material/',
	FIXED_PRICE_TRIAL = '/services/fixed-price/',
	RD = '/services/rd/',
	TESTING = '/services/testing/',
	BLOG = '/blog/',
	FCQ_CASE_STUDY = '/case-studies/finance-capital-platform/',
	INDAHASH_CASE_STUDY = '/case-studies/mobile-app-for-influencers/',
	QCHANGE_CASE_STUDY = '/case-studies/platform-for-management/',
	FOOTFALL_CASE_STUDY = '/case-studies/footfall-analytics-in-transportation/',
	SPARK_CASE_STUDY = '/case-studies/management-in-agro-industries/',
	TRANSCRIBE_CASE_STUDY = '/case-studies/transcription-and-annotation-platform/',
	SMARTFACTOR_CASE_STUDY = '/case-studies/smart-parking-sensors/',
	ZEBRA_CASE_STUDY = '/case-studies/active-pedestrian-crossing/',
}

export enum ExternalLinks {
	OCKO = 'https://ocko.pl/en/',
	BLOKO = 'https://bloko.embiq.com/',
}
